<template>
  <ContactWithoutCalling module="sales" />
</template>

<script>
import ContactWithoutCalling from "@/components/sales/kpi/ContactWithoutCalling.vue";

export default {
  name: "ContactWithoutCallingSales",
  components: {
    ContactWithoutCalling
  }
};
</script>
